var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accept-container"},[_c('a',{attrs:{"href":_vm.linkpage,"target":"_blank"}},[_vm._v("质量报告>>>")])])}
var staticRenderFns = []

export { render, staticRenderFns }